import { DashBox } from '@common/DashBox';
import { AddOutlined } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';

type NoContentCardProps = {
  title: string;
  description: string;
  buttonText: string;
  onClick: () => void;
};

export const NoContentCard = ({
  title,
  description,
  buttonText,
  onClick,
}: NoContentCardProps) => {
  return (
    <DashBox>
      <Typography variant="body1">{title}</Typography>
      <Typography variant="body2" color="textSecondary">
        {description}
      </Typography>
      <Button startIcon={<AddOutlined />} variant="contained" onClick={onClick}>
        {buttonText}
      </Button>
    </DashBox>
  );
};
